"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtonVariantValues = exports.IconButtonSizeValues = exports.IconButton = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var harris_icon_font_1 = __importDefault(require("@rotaryintl/harris-icon-font"));

var classnames_1 = __importDefault(require("classnames"));

require("./iconbutton.styles.css");

var colorClassMap = {
  primary: 'variant-primary',
  secondary: 'variant-secondary',
  destructive: 'variant-destructive',
  tertiary: 'variant-tertiary',
  elevated: 'variant-elevated',
  outlined: 'variant-outlined'
};
var IconButtonVariantValues = ['primary', 'secondary', 'tertiary', 'elevated', 'destructive', 'outlined'];
exports.IconButtonVariantValues = IconButtonVariantValues;
var IconButtonSizeValues = ['md'];
exports.IconButtonSizeValues = IconButtonSizeValues;

var IconButton = function (_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      icon = _a.icon,
      url = _a.url,
      _d = _a.style,
      style = _d === void 0 ? {
    width: 20,
    height: 20
  } : _d,
      target = _a.target,
      clickHandler = _a.clickHandler,
      className = _a.className,
      IconButtonRef = _a.IconButtonRef,
      rest = __rest(_a, ["variant", "disabled", "icon", "url", "style", "target", "clickHandler", "className", "IconButtonRef"]);

  var buttonClasses = (0, classnames_1.default)(className, // from className prop
  'rotaryui-icon-button', colorClassMap[variant], // main button type
  {
    disabled: disabled
  });
  /* Need to pass style as prop for xs,sm icon sizes */

  var innerElement = (0, jsx_runtime_1.jsx)("div", __assign({
    className: "rotaryui-icon-box"
  }, {
    children: icon ? (0, jsx_runtime_1.jsx)(harris_icon_font_1.default, {
      type: icon,
      style: style
    }) : null
  }));
  var returnElement;
  /* Conditionally return A, button, or span element */

  if (url) {
    buttonClasses = (0, classnames_1.default)(buttonClasses, ['link-styles-off']);
    returnElement = (0, jsx_runtime_1.jsx)("a", __assign({
      className: buttonClasses,
      href: url,
      target: target === null || target === void 0 ? void 0 : target.trim(),
      ref: IconButtonRef
    }, rest, {
      children: innerElement
    }));
  } else {
    returnElement = (0, jsx_runtime_1.jsx)("button", __assign({
      className: buttonClasses,
      onClick: clickHandler,
      disabled: disabled,
      ref: IconButtonRef
    }, rest, {
      children: innerElement
    }));
  }

  return returnElement;
};

exports.IconButton = IconButton;
exports.default = IconButton;